export default (date) => (date || '').slice(0, 10)
export const dateWithTime = (date) => (date || '').slice(0, 19).replace('T', ' ')
